import React, { useEffect, useRef, useState } from "react";
import home from "../assets/images/homelink.svg";
import annualsummary from "../assets/images/My_machine.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import DemoLogoBig from "../assets/images/MainLogoforMPD.svg";

import annualsummary1 from "../assets/images/annualSummary3.png";
import annualsummary2 from "../assets/images/annualSummary4.png";
import star from "../assets/images/stars.svg";
import searchicon from "../assets/images/searchicon.svg";
import sminfo from "../assets/images/sminfo.svg";
import folder from "../assets/images/folder.svg";
import fileIcon from "../assets/images/fileGrey.svg";
import download from "../assets/images/download.svg";
import copy from "../assets/images/copyIcon.svg";
import edit from "../assets/images/editaction.svg";
import code from "../assets/images/code.svg";
import forecast from "../assets/images/forecast.svg";
import pickup from "../assets/images/pickup.svg";
import stars from "../assets/images/stars.svg";
import crossarrow from "../assets/images/crossarrow.svg";
import call from "../assets/images/call.svg";
import email from "../assets/images/email.svg";
import activestatus from "../assets/images/activeStatus.svg";
import fourstar from "../assets/images/4star.svg";
import reviewprofile from "../assets/images/reviewprofile.png";
import emptystar from "../assets/images/emptystar.svg";
import profilepic from "../assets/images/dummy-profile-pic.jpg";
import comment from "../assets/images/comment.svg";
import redalert from "../assets/images/redalert.svg";
import {
  Accordion,
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Form,
  Nav,
  Tab,
  Table,
  InputGroup,
  Tabs,
  Overlay,
  Tooltip,
} from "react-bootstrap";
import BreadcrumbsNav from "./common-component/BreadcrumbsNav";
import { commonservices, CountCharacter } from "../services/CommonServices";
import StarRating from "./common-component/StarRating";
import Loader, { LoaderType } from "./common-component/Loader";
import { Link, useNavigate, useParams } from "react-router-dom";
import RejectModal from "../Modals/RejectModal";
import { apiCall } from "../services/AxiosService";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import InputDetail from "./ConfigurationComponent/InputDetail";
import Nodata from "./common-component/Nodata";
import { toast } from "react-toastify";
import MachineRejectModal from "../Modals/MachineRejectModal";
import dummyBanner from "../assets/images/dummyBanner.png";
import infoIcon from "../assets/images/infobtnblue.svg";
import { CodeBlock, github } from "react-code-blocks";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { GetCurrentWorkFlow } from "../services/ReduxTookit/Slice/WorkFlowRedux";
import { FaqGetList } from "../services/ReduxTookit/Slice/MachineFaqRedux";
import {
  GetMachineDetailByPrimaryKey,
  GetMachineVersionById,
  GetRepoFileContent,
  GetRepoStrcture,
  GetReviewerComment,
  UpdateMachineRetirementStatus,
  UpdateMachineStatus,
  UpdateReviewComment,
} from "../services/ReduxTookit/Slice/MachineRedux";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { a11yDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import SubmitLoading from "./common-component/Loaders/SubmitLoading";
import MainpageLoader from "./common-component/Loaders/MainpageLoader";

const FileStructure = ({
  data,
  getGitRepoFileContent,
  selectedFile,
  handleFileSelection,
}) => {
  const [expand, setExpand] = useState({});

  return (
    <>
      <div style={{ marginLeft: "5px" }}>
        {data?.map((item) => {
          if (item?.type === "dir") {
            return (
              <div className="code-folder-structure-single-folder">
                <div
                  className="folder-title cursor-pointer"
                  onClick={() => {
                    if (expand[item?.path]) {
                      delete expand[item?.path];
                    } else {
                      expand[item?.path] = item?.path;
                    }
                    setExpand({ ...expand });
                  }}
                >
                  <img src={folder} alt="folder" />
                  <h6>{item?.name}</h6>
                </div>
                <div className={expand[item?.path] ? "folder-body" : "d-none"}>
                  <FileStructure
                    data={item?.child}
                    getGitRepoFileContent={getGitRepoFileContent}
                    selectedFile={selectedFile}
                    handleFileSelection={handleFileSelection}
                  />
                </div>
              </div>
            );
          } else {
            return (
              <div className="code-folder-structure-single-folder">
                <div
                  className="cursor-pointer d-flex align-items-center gap-2"
                  onClick={(e) => {
                    e.preventDefault();
                    getGitRepoFileContent(item?.path);
                  }}
                >
                  <img src={fileIcon} alt="fileIcon" />
                  <p>{item?.name}</p>
                </div>
              </div>
            );
          }
        })}
      </div>
    </>
  );
};

function MachineReview() {
  const { id, version } = useParams();

  const navigate = useNavigate();
  const gitFileApiCountRef = useRef(0);
  const gitRepoApiCountRef = useRef(0);

  const dispatch = useDispatch();
  const handleImageClick = (imageSrc) => {
    setMainImage(imageSrc);
  };
  const [showFiles, setShowFiles] = useState("");
  const [activeTab, setActiveTab] = useState(1);
  const [rejectModalShow, setRejectModalShow] = useState(false);
  // const [FAQList, setFAQList] = useState(null);
  const [MachineDetails, setMachineDetails] = useState();

  const [mainImage, setMainImage] = useState("");
  const [machineVersionList, setMachineVersionList] = useState(null);
  const [TabState, setTabState] = useState("General Information");
  const [reviewWidths, setReviewWidths] = useState({
    total5start: "0",
    total4start: "0",
    total3start: "0",
    total2start: "0",
    total1start: "0",
  });
  const [reviewCheckList, setReviewCheckList] = useState(null);
  const [currentWorkflowList, setCurrentWorkflowList] = useState(null);
  const [machineDetailLoading, setMachineDetailLoading] = useState(false);
  const reviewCommentModalRef = useRef(null);
  const [showRejectMachine, setShowRejectMachine] = useState(false);
  const [machineStatusLoading, setMachineStatusLoading] = useState(false);
  const [retiermentApproveLoading, setRetiermentApproveLoading] =
    useState(false);
  const [retiermentRejectLoading, setRetiermentRejectLoading] = useState(false);
  const [retierMentForm, setRetierMentForm] = useState({
    datebyreviwer: "",
    reviwerreason: "",
    errors: {
      datebyreviwer: "",
      reviwerreason: "",
      ValidationRules: [
        {
          FieldName: "datebyreviwer",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "reviwerreason",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  const [fileStructureLoading, setFileStructureLoading] = useState(false);
  const [fileContentLoading, setFileContentLoading] = useState(false);
  const [fileStructure, setFileStructure] = useState(null);
  const [fileContent, setFileContent] = useState(null);
  const [selectedFile, setSelectedFile] = useState("");
  useEffect(() => {
    if (fileStructure) {
      setSelectedFile(fileStructure[0]?.name);
      getGitRepoFileContent(fileStructure[0]?.name);
    }
  }, [fileStructure]);
  const FAQListFromRedux = useSelector(
    (state) => state?.machinefaqredux?.FaqGetListData?.data
  );
  let FAQList = [];
  if (FAQListFromRedux?.isValidate) {
    FAQList = FAQListFromRedux?.data?.data;
  }

  function CustomtruncateText(text, length) {
    if (text.length > length) {
      return (
        <>
          {text.substring(0, length)} <span>more...</span>
        </>
      );
    } else {
      return text;
    }
  }

  const getFAQList = async () => {
    let body = {
      id: id,
    };
    dispatch(FaqGetList(body));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 105) {
        document.body.classList.add("scrolled");
        document.body.classList.add("sticky-panel");
      } else {
        document.body.classList.remove("scrolled");
        document.body.classList.remove("sticky-panel");
      }
    };

    // Ensure classes are reset on mount
    document.body.classList.remove("scrolled", "sticky-panel");

    // Check the current scroll position when component mounts
    handleScroll();

    // Add the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      // Remove the classes when component unmounts
      document.body.classList.remove("scrolled", "sticky-panel");
    };
  }, []); // Empty dependency array ensures this effect runs once

  const getMachineDetails = async () => {
    setMachineDetailLoading(true);
    let body = { id: id };
    dispatch(GetMachineDetailByPrimaryKey(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setMachineDetails(res?.payload?.data?.data);
        setMainImage(res?.payload?.data?.data?.dataList5[0]?.bannerurl);
        setMachineDetailLoading(false);
        setRetierMentForm({
          ...retierMentForm,
          datebyreviwer: res?.payload?.data?.data?.dataList7?.[0]
            ?.usersuggestdate
            ? commonservices.getDateInFormatCustom(
              res?.payload?.data?.data?.dataList7?.[0]?.usersuggestdate,
              null,
              "YYYY-MM-DD"
            )
            : "",
        });
      } else {
        setMachineDetails(null);
        setMainImage(null);
        setMachineDetailLoading(false);
      }
    });
  };

  const getReviewStatus = async () => {
    let body = {
      machineId: id ? parseInt(id) : 0,
      version: version,
    };
    dispatch(GetReviewerComment(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setReviewCheckList(res?.payload?.data?.data);
      } else {
        setReviewCheckList(null);
      }
    });
  };

  const updateReviewStatus = async (body) => {
    dispatch(UpdateReviewComment(body)).then((res) => {
      if (res?.payload?.isValidate) {
      } else {
        handleCheckListStatus(
          body?.booleanfield,
          !body?.booleanfieldvalue,
          body?.commentfield,
          reviewCheckList[body?.commentfield]
        );
        toast.error(res?.payload?.message);
      }
    });
  };

  const getMachineVersion = async () => {
    let body = {
      id: id,
    };
    dispatch(GetMachineVersionById(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let groupingJson = {};
        let dataFromApi = res?.payload?.data?.data?.dataList1;

        dataFromApi?.forEach((item) => {
          if (groupingJson?.[item?.versionnumber]) {
            groupingJson?.[item?.versionnumber]?.push(item);
          } else {
            groupingJson = {
              ...groupingJson,
              [item?.versionnumber]: [item],
            };
          }
        });
        setMachineVersionList(groupingJson);
      } else {
        setMachineVersionList(null);
      }
    });
  };

  const getCurrentWorkflow = async () => {
    dispatch(GetCurrentWorkFlow(id))?.then((response) => {
      if (response?.payload?.isValidate) {
        setCurrentWorkflowList(response?.payload?.data?.data);
      }

      if (!response?.payload?.isValidate) {
        setCurrentWorkflowList(null);
      }
    });
  };

  const updateMachineStatus = async (status, note) => {
    if (status !== "Rejected") {
      setMachineStatusLoading(true);
    }
    let body = {
      status: status ? status : "",
      note: note ? note : "",
      id,
    };
    dispatch(UpdateMachineStatus(body)).then((res) => {
      if (res?.payload?.isValidate) {
        if (status !== "Rejected") {
          setShowRejectMachine(false);
        }
        navigate("/machine-review");
      }

      if (!res?.payload?.isValidate) {
        setMachineStatusLoading(false);
      }
    });
  };

  const changeMachineRetirementStatus = async (body, setSpecificLoading) => {
    setSpecificLoading(true);
    let obj = commonservices.fnCheckValidationOfObject(retierMentForm);
    if (!obj?.isValid) {
      setSpecificLoading(false);
      setRetierMentForm({ ...obj?.obj });
      return;
    }
    dispatch(UpdateMachineRetirementStatus(body)).then((res) => {
      if (res?.payload?.isValidate) {
        setSpecificLoading(false);
        navigate("/machine-review");
      } else {
        setSpecificLoading(false);
      }
    });
  };

  const getGitRepoStructure = async () => {
    setFileStructureLoading(true);
    let body = {
      machineid: id ? parseInt(id) : 0,
      versionnumber: version,
    };
    dispatch(GetRepoStrcture(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let dataFromApi = res?.payload?.data?.data;

        function buildRepoHierarchy(data) {
          const root = [];

          function findOrCreateFolder(currentLevel, folderName) {
            let folder = currentLevel.find((item) => item.name === folderName);
            if (!folder) {
              folder = {
                type: "dir",
                name: folderName,
                path: folderName,
                child: [],
              };
              currentLevel.push(folder);
            }
            return folder;
          }

          function insertFile(pathParts, file) {
            let currentLevel = root;
            pathParts.forEach((part, index) => {
              if (index === pathParts.length - 1) {
                currentLevel.push({
                  type: file.type,
                  name: file.name,
                  path: file.path,
                  child: [],
                });
              } else {
                const folder = findOrCreateFolder(currentLevel, part);
                currentLevel = folder.child;
              }
            });
          }

          // Loop through each file/folder and insert it into the hierarchy
          data?.forEach((item) => {
            const pathParts = item.path.split("/");
            insertFile(pathParts, item);
          });

          return root;
        }

        // Get the repository hierarchy in the desired format
        const repoHierarchy = buildRepoHierarchy(dataFromApi?.structure);
        setFileStructure(repoHierarchy);
        setFileStructureLoading(false);
      }

      if (!res?.payload?.isValidate) {
        gitRepoApiCountRef.current = gitRepoApiCountRef.current + 1;
        setFileStructureLoading(false);
        if (gitRepoApiCountRef.current <= 1) {
          getGitRepoStructure();
        }
      }
    });
  };

  const getGitRepoFileContent = async (filePath) => {
    setSelectedFile(filePath);
    setFileContentLoading(true);
    let body = {
      machineid: id ? parseInt(id) : 0,
      versionnumber: version,
      fileurl: filePath,
    };
    dispatch(GetRepoFileContent(body)).then((res) => {
      if (res?.payload?.isValidate) {
        let dataFromApi = res?.payload?.data?.data;
        let getLng = dataFromApi?.path?.split(".");
        let groupingJson = {
          ...dataFromApi,
          language:
            getLng?.length > 1 ? getLng[getLng?.length - 1] : "dockerfile",
        };
        setFileContent(groupingJson);
        setFileContentLoading(false);
      }
      if (!res?.payload?.isValidate) {
        gitFileApiCountRef.current = gitFileApiCountRef.current + 1;
        setFileContent(null);
        setFileContentLoading(false);
        if (gitFileApiCountRef.current <= 1) {
          getGitRepoFileContent(filePath);
        }
      }
    });
  };

  const handleFileSelection = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (MachineDetails?.dataList2?.[0]) {
      const data = MachineDetails?.dataList2[0];
      const totalReviews =
        data["5star"] +
        data["4star"] +
        data["3star"] +
        data["2star"] +
        data["1star"];

      const calculateWidthPercentage = (count) => {
        if (totalReviews > 0 && count > 0) {
          return `${(count / totalReviews) * 100}`;
        }
        return "0";
      };
      setReviewWidths({
        total5start: calculateWidthPercentage(data["5star"]),
        total4start: calculateWidthPercentage(data["4star"]),
        total3start: calculateWidthPercentage(data["3star"]),
        total2start: calculateWidthPercentage(data["2star"]),
        total1start: calculateWidthPercentage(data["1star"]),
      });
    }
  }, [MachineDetails]);

  useEffect(() => {
    getReviewStatus();
    getFAQList();
    getMachineDetails();
    getMachineVersion();
    getCurrentWorkflow();
    getGitRepoStructure();
  }, []);

  const checkListForMachineReview = [
    {
      title: "General Information",
      subTitle: "(Mandatory)",
      checkList: [
        {
          title: "Banner Image",
          booleanField: "bannerimage",
          commentField: "bannerimagecomment",
        },
        {
          title: "Machine Overview",
          booleanField: "machineoverview",
          commentField: "machineoverviewcomment",
        },
        {
          title: "Classification",
          booleanField: "classification",
          commentField: "classificationcomment",
        },
        {
          title: "Compatibility and Dependencies",
          booleanField: "compatibility",
          commentField: "compatibilitycomment",
        },
        {
          title: "Specifications",
          booleanField: "specification",
          commentField: "specificationcomment",
        },
      ],
    },
    {
      title: "Source Code",
      subTitle: "(Mandatory)",
      checkList: [
        {
          title: "Code Structure",
          booleanField: "codestructure",
          commentField: "codestructurecomment",
        },
        {
          title: "Code Quality",
          booleanField: "codequality",
          commentField: "codequalitycomment",
        },
        {
          title: "Functionality",
          booleanField: "functionality",
          commentField: "functionalitycomment",
        },
        {
          title: "Security",
          booleanField: "security",
          commentField: "securitycomment",
        },
        {
          title: "Performance and Efficiency",
          booleanField: "performance",
          commentField: "performancecomment",
        },
        {
          title: "Testing and Coverage",
          booleanField: "testingandcoverage",
          commentField: "testingandcoveragecomment",
        },
        {
          title: "Compliance and Standards",
          booleanField: "compliancestandard",
          commentField: "compliancestandardcomment",
        },
        {
          title: "Mock Test",
          booleanField: "mocktest",
          commentField: "mocktestcomment",
        },
      ],
    },
    {
      title: "Optionals",
      subTitle: "",
      checkList: [
        {
          title: "FAQ Added",
          booleanField: "faqadded",
          commentField: "faqaddedcomment",
        },
        {
          title: "Parameters Added",
          booleanField: "parametersadded",
          commentField: "parametersaddedcomment",
        },
      ],
    },
  ];

  const isButtonDisabled = (type) => {
    let isDisabled = false;

    if (reviewCheckList) {
      if (type === "Approve") {
        for (let i = 0; i < checkListForMachineReview?.length; i++) {
          // if (checkListForMachineReview?.[i]?.subTitle) {
          let checkListArr = checkListForMachineReview?.[i]?.checkList;

          for (let j = 0; j < checkListArr?.length; j++) {
            if (checkListForMachineReview?.[i]?.subTitle) {
              if (!reviewCheckList?.[checkListArr?.[j]?.booleanField]) {
                isDisabled = true;
              }
            } else {
              if (
                reviewCheckList?.[checkListArr?.[j]?.booleanField] === false &&
                reviewCheckList?.[checkListArr?.[j]?.commentField]
              ) {
                isDisabled = true;
              }
            }
          }
          // }
        }
      } else {
        isDisabled = true;
        for (let i = 0; i < checkListForMachineReview?.length; i++) {
          // if (checkListForMachineReview?.[i]?.subTitle) {
          let checkListArr = checkListForMachineReview?.[i]?.checkList;

          for (let j = 0; j < checkListArr?.length; j++) {
            if (
              reviewCheckList?.[checkListArr?.[j]?.booleanField] === false &&
              reviewCheckList?.[checkListArr?.[j]?.commentField]
            ) {
              isDisabled = false;
              break;
            }
          }
          // }
        }
      }
    } else {
      isDisabled = true;
    }

    return isDisabled;
  };

  const [showInputDetailPopup, setShowInputDetailPopu] = useState(false);
  const targetInputDetail = useRef();
  const paraDetailRef = useRef();

  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleShowInputDetailPopup = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowInputDetailPopu(!showInputDetailPopup);
  };

  const handleCheckListStatus = (
    booleanField,
    booleanFieldValue,
    commentField,
    commentFieldValue
  ) => {
    setReviewCheckList({
      ...reviewCheckList,
      [booleanField]: booleanFieldValue,
      [commentField]: commentFieldValue,
    });
  };

  const BreadcrumbSingle = [
    // {
    //   name: param?.pagename,
    //   link: param?.pagename !== "my machine" ? "/marketplace" : "/machine",
    //   active: false,
    // },
    {
      name: "Machine Review",
      active: true,
    },
  ];

  return (
    <div className="dashboard-main market-place-page-main market-place-detail-page-main">
      {(retiermentRejectLoading ||
        retiermentApproveLoading ||
        machineStatusLoading) && <MainpageLoader />}
      <div className="all-page-top">
        <div className="stickypanelnew reviewsticky">
          <Container>
            <div className="d-flex justify-content-between">
              <div className="d-flex stickeyinner">
                <div className="bradnew">
                  <BreadcrumbsNav pageNav={BreadcrumbSingle} />
                </div>
                <div className="top-left-sect-detail-content">
                  <div className="title-rating">
                    <div className="version-name cursor-pointer">{version}</div>
                    {MachineDetails?.dataList2?.[0]?.averagerating > 0 && (
                      <div className="rating-main">
                        <img src={star} alt="star" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="top-section-right">
                <h5>
                  {MachineDetails?.dataList1?.[0]?.price
                    ? `$${MachineDetails?.dataList1?.[0]?.price}`
                    : `Free`}
                </h5>
              </div>
            </div>
          </Container>
        </div>
        <Container>
          <div className="top-section-all d-block">
            <div className="top-section-left">
              <BreadcrumbsNav pageNav={BreadcrumbSingle} />
              {/* <div className="bread-crumb-main">
                <Link to="/machine-review">
                  <img src={home} alt="home" />
                </Link>
                <p className="current-page">
                  <span>{">  "}</span>Machine Review
                </p>
              </div> */}
              {machineDetailLoading ? (
                <Loader type={LoaderType.ReviewDetailHeading} />
              ) : (
                <div className="d-flex align-items-center justify-content-between w-100 mb40">
                  <div className="top-left-sect-detail marketplace-profile-image">
                    <div className="single-market-place-img">
                      <img
                        src={
                          MachineDetails?.dataList1[0]?.machinelogo !== "" &&
                            MachineDetails?.dataList1[0]?.machinelogo !== null
                            ? MachineDetails?.dataList1[0]?.machinelogo
                            : DemoLogo
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = DemoLogo;
                        }}
                        alt="machinelogo"
                      />
                    </div>
                    <div className="top-left-sect-detail-content">
                      <div className="title-rating">
                        <h5>{MachineDetails?.dataList1[0]?.machinename}</h5>
                        <div className="version-name cursor-pointer">
                          {version}
                        </div>
                        {MachineDetails?.dataList2?.[0]?.averagerating > 0 && (
                          <div className="rating-main">
                            <img src={star} alt="star" />
                            <p>
                              {MachineDetails?.dataList2?.[0]?.averagerating?.toFixed(
                                1
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: MachineDetails?.dataList2[0]?.shortdescription
                            ? commonservices.truncateText(
                              commonservices.stripHTML(
                                MachineDetails?.dataList2[0]?.shortdescription
                              ),
                              CountCharacter.MarketPlaceShortDetail
                            )
                            : "",
                        }}
                      />
                    </div>
                  </div>
                  <div className="top-section-right">
                    <h5>
                      {MachineDetails?.dataList1?.[0]?.price
                        ? `$${MachineDetails?.dataList1?.[0]?.price}`
                        : `Free`}
                    </h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </div>
      <div className="main-page-content profilecomplate-common">
        <Container>
          <div className="all-marketplace-wrapper">
            <Row>
              <Col xl={9}>
                <div className="parentstickey">
                  {machineDetailLoading ? (
                    <Loader type={LoaderType.ReviewDetailLeft} />
                  ) : (
                    // <Col xl={9}>
                    //   <div className="parentstickey">
                    <div className="tabin-title tabborder reviewmarket-sourcecode">
                      <div className="tabing-custom">{TabState}</div>
                      <div className="mysticketab">
                        <Tabs
                          defaultActiveKey={TabState}
                          id="uncontrolled-tab-example"
                          className="mb-3 custom-tabing reviewcustom"
                          fill
                          onSelect={(e) => setTabState(e)}
                        >
                          <Tab
                            eventKey="General Information"
                            title="General Information"
                          >
                            <div className="all-report-images">
                              {/* {MachineDetails?.dataList5?.length > 0 && ( */}
                              <div className="all-report-images">
                                <img
                                  src={mainImage ? mainImage : DemoLogoBig}
                                  alt="annualsummary1"
                                  className="main-big-img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = DemoLogoBig;
                                  }}
                                />

                                <div className="smaller-size-images">
                                  {MachineDetails?.dataList5?.length > 0 &&
                                    MachineDetails?.dataList5?.map((item) => (
                                      <img
                                        src={item?.thumbnailurl}
                                        alt="annualsummary1"
                                        className={
                                          mainImage === item?.thumbnailurl
                                            ? "smaller-size-img active"
                                            : "smaller-size-img"
                                        }
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null;
                                          currentTarget.src = DemoLogo;
                                        }}
                                        onClick={() =>
                                          handleImageClick(item?.bannerurl)
                                        }
                                      />
                                    ))}
                                </div>
                              </div>
                              {/* )} */}
                            </div>

                            <div className="key-benifits-main">
                              <h4>Machine Overview</h4>
                              <ul>
                                <li>
                                  <strong>Machine Name : </strong>
                                  {MachineDetails?.dataList1[0]?.machinename
                                    ? MachineDetails?.dataList1[0]?.machinename
                                    : " - "}
                                </li>
                                <li>
                                  <strong>Title : </strong>
                                  {MachineDetails?.dataList2[0]?.title
                                    ? MachineDetails?.dataList2[0]?.title
                                    : " - "}
                                </li>
                                <li>
                                  <div className="d-flex gap-1">
                                    <strong>Short Description : </strong>
                                    <div className="shortdescription-inner">
                                      {MachineDetails?.dataList2[0]
                                        ?.shortdescription ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              MachineDetails?.dataList2[0]
                                                ?.shortdescription,
                                          }}
                                        />
                                      ) : (
                                        "  - "
                                      )}
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <strong>Detail Description : </strong>
                                  <div>
                                    {MachineDetails?.dataList2[0]
                                      ?.detaildescription ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            MachineDetails?.dataList2[0]
                                              ?.detaildescription,
                                        }}
                                      />
                                    ) : (
                                      "  - "
                                    )}
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <strong>Machine Document : </strong>
                                    {MachineDetails?.dataList1?.[0]
                                      ?.documentpathurl && (
                                        <Link
                                          target="_blank"
                                          className="theme-color-text"
                                          to={
                                            MachineDetails?.dataList1?.[0]
                                              ?.documentpathurl
                                          }
                                        >
                                          <span className="input-download-icon">
                                            <img
                                              src={download}
                                              alt="downloadIcon"
                                            />
                                            Download
                                          </span>
                                        </Link>
                                      )}
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="key-benifits-main">
                              <h4>Classification</h4>
                              <ul>
                                <li>
                                  <strong>Industry : </strong>
                                  {/* {MachineDetails?.dataList1[0]?.industryname ? (
                            <Link to="/" className="theme-color-text">
                              {MachineDetails?.dataList1[0]?.industryname}
                            </Link>
                          ) : (
                            " - "
                          )} */}
                                  {MachineDetails?.dataList1[0]?.industryname
                                    ? MachineDetails?.dataList1[0]?.industryname
                                    : "-"}
                                </li>
                                <li>
                                  <strong>Category : </strong>
                                  {MachineDetails?.dataList1[0]?.categoryname
                                    ? MachineDetails?.dataList1[0]?.categoryname
                                    : " - "}
                                </li>
                                <li>
                                  <strong>Sub Category : </strong>
                                  {MachineDetails?.dataList1[0]?.subcategoryname
                                    ? MachineDetails?.dataList1[0]
                                      ?.subcategoryname
                                    : " - "}
                                </li>
                              </ul>
                            </div>
                            <div className="key-benifits-main my-3">
                              <h4>Compatibility And Dependencies</h4>
                              <ul>
                                <li>
                                  <strong>
                                    Preferred Dependent Machines :{" "}
                                  </strong>
                                  {MachineDetails?.dataList2[0]
                                    ?.dependentmachines
                                    ? MachineDetails?.dataList2[0]
                                      ?.dependentmachines
                                    : " - "}
                                </li>
                                <li>
                                  <strong>Compatible Machines : </strong>
                                  {MachineDetails?.dataList2[0]
                                    ?.compatiblemachines
                                    ? MachineDetails?.dataList2[0]
                                      ?.compatiblemachines
                                    : " - "}
                                </li>
                                <li>
                                  <strong>Version : </strong>
                                  {MachineDetails?.dataList1[0]?.versionnumber
                                    ? MachineDetails?.dataList1[0]
                                      ?.versionnumber
                                    : " - "}
                                </li>
                              </ul>
                            </div>
                            <div className="key-benifits-main">
                              <h4>Specifications</h4>
                              <ul>
                                <li>
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <strong>Input Specifications : </strong>
                                    {MachineDetails?.dataList1?.[0]
                                      ?.inputsamplefileurl && (
                                        <Link
                                          target="_blank"
                                          className="theme-color-text"
                                          to={
                                            MachineDetails?.dataList1?.[0]
                                              ?.inputsamplefileurl
                                          }
                                        >
                                          <span className="input-download-icon">
                                            <img
                                              src={download}
                                              alt="downloadIcon"
                                            />
                                            Download
                                          </span>
                                        </Link>
                                      )}
                                  </div>
                                  {MachineDetails?.dataList2[0]
                                    ?.inputdescription ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          MachineDetails?.dataList2[0]
                                            ?.inputdescription,
                                      }}
                                    />
                                  ) : (
                                    " - "
                                  )}
                                </li>
                                <li>
                                  <div className="d-flex align-items-center gap-2 mb-1">
                                    <strong>Output Specifications : </strong>
                                    {MachineDetails?.dataList1?.[0]
                                      ?.outputsamplefileurl && (
                                        <Link
                                          target="_blank"
                                          className="theme-color-text"
                                          to={
                                            MachineDetails?.dataList1?.[0]
                                              ?.outputsamplefileurl
                                          }
                                        >
                                          <span className="input-download-icon">
                                            <img
                                              src={download}
                                              alt="downloadIcon"
                                            />
                                            Download
                                          </span>
                                        </Link>
                                      )}
                                  </div>
                                  {MachineDetails?.dataList2[0]
                                    ?.outputdescription ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          MachineDetails?.dataList2[0]
                                            ?.outputdescription,
                                      }}
                                    />
                                  ) : (
                                    " - "
                                  )}
                                </li>
                              </ul>
                            </div>
                            <div className="key-benifits-main my-3">
                              <h4>Infrastructure Requirement</h4>
                              <ul className="infrastructure-requirement">
                                <li>
                                  <strong>OS Requirement : </strong>
                                  {MachineDetails?.dataList2[0]?.osrequirmet
                                    ? MachineDetails?.dataList2[0]?.osrequirmet
                                    : " - "}
                                </li>
                                {/* <li>
                              <strong>Storage : </strong>
                              {MachineDetails?.dataList2[0]?.storage
                                ? MachineDetails?.dataList2[0]?.storage
                                : " - "}
                            </li> */}
                                <li>
                                  <strong>CPU : </strong>
                                  {MachineDetails?.dataList2[0]?.cpu
                                    ? MachineDetails?.dataList2[0]?.cpu
                                    : " - "}
                                </li>
                                <li>
                                  <strong>Cloud : </strong>
                                  {MachineDetails?.dataList2[0]?.cloud
                                    ? MachineDetails?.dataList2[0]?.cloud
                                    : " - "}
                                </li>
                                <li>
                                  <strong>RAM : </strong>
                                  {MachineDetails?.dataList2[0]?.ram
                                    ? MachineDetails?.dataList2[0]?.ram
                                    : " - "}
                                </li>
                              </ul>
                            </div>
                            <div className="key-benifits-main">
                              <h4>Usage Statistics</h4>
                              <ul className="infrastructure-requirement">
                                <li>
                                  <strong>Total OnBoarded : </strong>
                                  {MachineDetails?.dataList2[0]?.totlworkflows
                                    ? commonservices.NumberCalculateValue(
                                      MachineDetails?.dataList2[0]
                                        ?.totlworkflows
                                    )
                                    : " 0 "}
                                </li>
                                <li>
                                  <strong>Active OnBoarding : </strong>
                                  {MachineDetails?.dataList2[0]?.activeworkflows
                                    ? commonservices.NumberCalculateValue(
                                      MachineDetails?.dataList2[0]
                                        ?.activeworkflows
                                    )
                                    : " 0 "}
                                </li>
                              </ul>
                            </div>
                          </Tab>

                          {MachineDetails?.dataList3?.length > 0 && (
                            <Tab eventKey="Parameters" title="Parameters">
                              <div className="table-wrapper-main">
                                <Table responsive>
                                  <thead>
                                    <tr>
                                      <th className="width450">
                                        Parameter Name
                                      </th>
                                      <th className="">Type</th>
                                      <th className="text-end width100">
                                        Description
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {MachineDetails?.dataList3?.length > 0 ? (
                                      MachineDetails?.dataList3?.map((item) => {
                                        return (
                                          <tr
                                            key={`parameter${item?.machineconfigparaid}`}
                                          >
                                            <td className="text-capitalize width450">
                                              {item?.parakey}
                                            </td>
                                            <td className="text-capitalize">
                                              {item?.paratype}
                                            </td>
                                            <td className="text-end width100">
                                              {item?.details && (
                                                <img
                                                  id={`parameter${item?.machineconfigparaid}`}
                                                  src={sminfo}
                                                  alt="sminfo"
                                                  className="sminfo-in-table cursor-pointer"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    targetInputDetail.current =
                                                      document.querySelector(
                                                        `#parameter${item?.machineconfigparaid}`
                                                      );
                                                    paraDetailRef.current =
                                                      item;
                                                    handleOverlay(e);
                                                    setShowInputDetailPopu(
                                                      !showInputDetailPopup
                                                    );
                                                    handleShowInputDetailPopup();
                                                  }}
                                                />
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr className="text-center">
                                        <td colSpan={3}>
                                          <Nodata />
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </Tab>
                          )}

                          {machineVersionList && (
                            <Tab eventKey="Versions" title="Versions">
                              <div className="versions-main">
                                <Accordion className="versions-accordion">
                                  {machineVersionList ? (
                                    Object.entries(machineVersionList)?.map(
                                      ([key, value]) => {
                                        return (
                                          <Accordion.Item eventKey={`${key}`}>
                                            <Accordion.Header>
                                              <span>{key}</span>
                                              <span>
                                                {value?.[0]?.entrydate
                                                  ? commonservices.getDateInFormatCustom(
                                                    value?.[0]?.entrydate,
                                                    null,
                                                    "MMMM DD,YYYY"
                                                  )
                                                  : "-"}
                                              </span>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                              {value?.map((valueItem) => {
                                                return (
                                                  <div className="version-data">
                                                    <p className="versionDate">
                                                      {valueItem?.entrydate
                                                        ? commonservices.getDateInFormatCustom(
                                                          valueItem?.entrydate,
                                                          null,
                                                          "MMMM DD, YYYY"
                                                        )
                                                        : "-"}
                                                    </p>
                                                    <div className="machine-accordion-data">
                                                      <p
                                                        dangerouslySetInnerHTML={{
                                                          __html:
                                                            valueItem?.bugresolved
                                                              ? valueItem?.bugresolved
                                                              : "-",
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        );
                                      }
                                    )
                                  ) : (
                                    <Nodata />
                                  )}
                                </Accordion>
                              </div>
                            </Tab>
                          )}

                          {MachineDetails?.dataList4?.length > 0 && (
                            <Tab
                              eventKey="Review & Ratings"
                              title="Review & Ratings"
                            >
                              <div className="all-reviews-main marketplace-review-main mt-3">
                                <div className="all-reviews-top mt-5">
                                  <div className="all-reviews-top-single">
                                    <h4>Total Reviews</h4>
                                    <h3>
                                      {commonservices.NumberCalculateValue(
                                        MachineDetails?.dataList2[0]
                                          ?.totalreview
                                      )}
                                    </h3>
                                  </div>
                                  <div className="all-reviews-top-single">
                                    <h4>Total Rating</h4>
                                    <h3>
                                      {commonservices.NumberCalculateValue(
                                        MachineDetails?.dataList2[0]
                                          ?.totalrating
                                      )}
                                    </h3>
                                  </div>
                                  <div className="all-reviews-top-single">
                                    <h4>Average Rating</h4>
                                    <h3 className="d-flex gap-2">
                                      {MachineDetails?.dataList2[0]?.averagerating?.toFixed()}
                                      <span>
                                        {"  "}
                                        <StarRating
                                          filledStars={
                                            MachineDetails?.dataList2[0]
                                              ?.averagerating
                                          }
                                        />
                                      </span>
                                    </h3>
                                    {/* <h6>
                                {commonservices.NumberCalculateValue(
                                  MachineDetails?.dataList2[0]?.totalrating
                                )}{" "}
                                ratings
                              </h6> */}
                                  </div>
                                  <div className="all-review-star-vise w-100">
                                    <div className="five-star-rating">
                                      <div className="d-flex align-items-center gap-1">
                                        <img src={star} alt="emptystar" />
                                        <p>5</p>
                                      </div>
                                      <div
                                        className="review-line"
                                        // style={{
                                        //   width: reviewWidths.total5start,
                                        //   background: "#3ABAA0",
                                        // }}
                                        style={{
                                          width: `${2 +
                                            parseInt(reviewWidths.total5start)
                                            }%`,
                                          background: "#3ABAA0",
                                        }}
                                      ></div>
                                      <span>
                                        {commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]?.[
                                          "5star"
                                          ]
                                        )}
                                      </span>
                                    </div>
                                    <div className="five-star-rating">
                                      <div className="d-flex align-items-center gap-1">
                                        <img src={star} alt="star" />
                                        <p>4</p>
                                      </div>
                                      <div
                                        className="review-line"
                                        // style={{
                                        //   width: reviewWidths.total4start,
                                        //   background: "#DC7EFF",
                                        // }}
                                        style={{
                                          width: `${2 +
                                            parseInt(reviewWidths.total4start)
                                            }%`,
                                          background: "#DC7EFF",
                                        }}
                                      ></div>
                                      <span>
                                        {commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]?.[
                                          "4star"
                                          ]
                                        )}
                                      </span>
                                    </div>
                                    <div className="five-star-rating">
                                      <div className="d-flex align-items-center gap-1">
                                        <img src={star} alt="star" />
                                        <p>3</p>
                                      </div>
                                      <div
                                        className="review-line"
                                        // style={{
                                        //   width: reviewWidths.total3start,
                                        //   background: "#F5C044",
                                        // }}
                                        style={{
                                          width: `${2 +
                                            parseInt(reviewWidths.total3start)
                                            }%`,
                                          background: "#F5C044",
                                        }}
                                      ></div>
                                      <span>
                                        {commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]?.[
                                          "3star"
                                          ]
                                        )}
                                      </span>
                                    </div>
                                    <div className="five-star-rating">
                                      <div className="d-flex align-items-center gap-1">
                                        <img src={star} alt="star" />
                                        <p>2</p>
                                      </div>
                                      <div
                                        className="review-line"
                                        // style={{
                                        //   width: reviewWidths.total2start,
                                        //   background: "#35C4F3",
                                        // }}
                                        style={{
                                          width: `${2 +
                                            parseInt(reviewWidths.total2start)
                                            }%`,
                                          background: "#35C4F3",
                                        }}
                                      ></div>
                                      <span>
                                        {commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]?.[
                                          "2star"
                                          ]
                                        )}
                                      </span>
                                    </div>
                                    <div className="five-star-rating">
                                      <div className="d-flex align-items-center gap-1">
                                        <img src={star} alt="star" />
                                        <p>1</p>
                                      </div>
                                      <div
                                        className="review-line"
                                        // style={{
                                        //   width: reviewWidths.total1start,
                                        //   background: "#F96B0D",
                                        // }}
                                        style={{
                                          width: `${2 +
                                            parseInt(reviewWidths.total1start)
                                            }%`,
                                          background: "#F96B0D",
                                        }}
                                      ></div>
                                      <span>
                                        {commonservices.NumberCalculateValue(
                                          MachineDetails?.dataList2[0]?.[
                                          "1star"
                                          ]
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="all-written-review">
                                  {MachineDetails?.dataList4?.length > 0 &&
                                    MachineDetails?.dataList4?.map(
                                      (item_md4, index_md4) => (
                                        <div
                                          key={index_md4}
                                          className="single-written-review"
                                        >
                                          <div className="single-written-review-left">
                                            <img
                                              src={
                                                item_md4?.profilepic
                                                  ? item_md4?.profilepic
                                                  : profilepic
                                              }
                                              alt="profilepic"
                                              onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = profilepic;
                                              }}
                                              className="reviewprofile"
                                            />
                                            <div>
                                              <h5>
                                                {item_md4?.displayname}
                                                {/* {commonservices.truncateText(
                                                  ,
                                                  CountCharacter.ReviewTitle
                                                )} */}
                                              </h5>
                                              <p>
                                                {item_md4?.entrydate
                                                  ? commonservices.getDateInFormatCustom(
                                                    item_md4?.entrydate,
                                                    null,
                                                    "MM/DD/yyyy"
                                                  )
                                                  : " - "}
                                              </p>
                                              <StarRating
                                                filledStars={
                                                  item_md4?.userrating
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="single-written-review-right">
                                            <p>
                                              {CustomtruncateText(
                                                item_md4?.userreview,
                                                400
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </Tab>
                          )}

                          {FAQList && (
                            <Tab eventKey="FAQs" title="FAQs">
                              <div className="faqs-main">
                                <div className="all-categories-of-market-place">
                                  <Accordion className="">
                                    {FAQList?.length > 0 ? (
                                      FAQList?.map((item) => {
                                        return (
                                          <Accordion.Item
                                            eventKey={`${item?.faqid}`}
                                            key={item?.faqid}
                                          >
                                            <Accordion.Header>
                                              <span>
                                                <b>{item?.question}</b>
                                              </span>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                              <p>{item?.answer}</p>
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        );
                                      })
                                    ) : (
                                      <Nodata />
                                    )}
                                  </Accordion>
                                </div>
                              </div>
                            </Tab>
                          )}

                          {currentWorkflowList?.dataList1?.length > 0 && (
                            <Tab
                              eventKey="Current Workflow"
                              title="Current Workflow"
                            >
                              <div className="table-wrapper-main">
                                <Table responsive>
                                  <thead>
                                    <tr>
                                      <th>Project Name</th>
                                      <th className="width150 text-center">
                                        Property
                                      </th>
                                      <th className="text-center">
                                        Success/Failed
                                      </th>
                                      <th className="text-center">
                                        last update
                                      </th>
                                      <th className="text-center">
                                        next schedule
                                      </th>
                                      <th className="text-center">Version</th>
                                      <th className="width75">status</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {currentWorkflowList?.dataList1?.length >
                                      0 ? (
                                      currentWorkflowList?.dataList1?.map(
                                        (item) => {
                                          return (
                                            <tr key={item?.workflowid}>
                                              <td className="theme-color-text fw600">
                                                {item?.workflowname}
                                              </td>
                                              <td className="text-center">
                                                {item?.totalmachine
                                                  ? item?.totalmachine
                                                  : "-"}
                                              </td>
                                              <td className="text-center">
                                                <span className="green-color-text">
                                                  {item?.totalsuccessed
                                                    ? item?.totalsuccessed
                                                    : "-"}
                                                </span>
                                                <span className="red-color-text">
                                                  /
                                                  {item?.totalfailed
                                                    ? item?.totalfailed
                                                    : "-"}
                                                </span>
                                              </td>
                                              <td className=" text-center">
                                                {item?.lastrunon
                                                  ? commonservices.getDateInFormatCustom(
                                                    item?.lastrunon,
                                                    null,
                                                    "MM/DD/yyyy"
                                                  )
                                                  : "-"}
                                              </td>
                                              <td className=" text-center">
                                                {item?.nextrunon
                                                  ? commonservices.getDateInFormatCustom(
                                                    item?.nextrunon,
                                                    null,
                                                    "MM/DD/yyyy"
                                                  )
                                                  : "-"}
                                              </td>
                                              <td className="theme-color-text fw600 text-center">
                                                {item?.versionnumber
                                                  ? item?.versionnumber
                                                  : "-"}
                                              </td>
                                              <td>
                                                {item?.laststatus
                                                  ? commonservices.getStatus(
                                                    item?.laststatus
                                                  )
                                                  : "-"}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    ) : (
                                      <tr className="text-center">
                                        <td colSpan={7}>
                                          <Nodata />
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </Tab>
                          )}

                          {(MachineDetails?.dataList2[0]?.inputdescription ||
                            MachineDetails?.dataList2[0]
                              ?.outputdescription) && (
                              <Tab eventKey="Sample Data" title="Sample Data">
                                <div className="key-benifits-main">
                                  <h4>Specifications</h4>
                                  <ul>
                                    <li>
                                      <div className="d-flex align-items-center gap-2 mb-1">
                                        <strong>Input Specifications : </strong>
                                        {MachineDetails?.dataList1?.[0]
                                          ?.inputsamplefileurl && (
                                            <Link
                                              target="_blank"
                                              className="theme-color-text"
                                              to={
                                                MachineDetails?.dataList1?.[0]
                                                  ?.inputsamplefileurl
                                              }
                                            >
                                              <span className="input-download-icon">
                                                <img
                                                  src={download}
                                                  alt="downloadIcon"
                                                />
                                                Download
                                              </span>
                                            </Link>
                                          )}
                                      </div>
                                      {MachineDetails?.dataList2[0]
                                        ?.inputdescription ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              MachineDetails?.dataList2[0]
                                                ?.inputdescription,
                                          }}
                                        />
                                      ) : (
                                        " - "
                                      )}
                                    </li>
                                    <li>
                                      <div className="d-flex align-items-center gap-2 mb-1">
                                        <strong>Output Specifications : </strong>
                                        {MachineDetails?.dataList1?.[0]
                                          ?.outputsamplefileurl && (
                                            <Link
                                              target="_blank"
                                              className="theme-color-text"
                                              to={
                                                MachineDetails?.dataList1?.[0]
                                                  ?.outputsamplefileurl
                                              }
                                            >
                                              <span className="input-download-icon">
                                                <img
                                                  src={download}
                                                  alt="downloadIcon"
                                                />
                                                Download
                                              </span>
                                            </Link>
                                          )}
                                      </div>
                                      {MachineDetails?.dataList2[0]
                                        ?.outputdescription ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              MachineDetails?.dataList2[0]
                                                ?.outputdescription,
                                          }}
                                        />
                                      ) : (
                                        " - "
                                      )}
                                    </li>
                                  </ul>
                                </div>
                              </Tab>
                            )}

                          <Tab eventKey="Source Code" title="Source Code">
                            {fileStructureLoading ? (
                              <Loader type={LoaderType.SourceCode} count={13} />
                            ) : (
                              <>
                                {fileStructure?.length > 0 ? (
                                  <div className="source-code-main">
                                    <Col xl={12}>
                                      <Row>
                                        <Col xl={3}>
                                          <div className="source-code-left">
                                            <div className="code-folder-structure-wrapper">
                                              {fileStructureLoading ? (
                                                <div className="m-2">
                                                  <Loader
                                                    type={LoaderType.Files}
                                                    count={13}
                                                  />
                                                </div>
                                              ) : (
                                                fileStructure && (
                                                  <FileStructure
                                                    data={fileStructure}
                                                    getGitRepoFileContent={
                                                      getGitRepoFileContent
                                                    }
                                                    selectedFile={selectedFile}
                                                    handleFileSelection={
                                                      handleFileSelection
                                                    }
                                                  />
                                                )
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                        <Col xl={9}>
                                          <div className="source-code-right w-100">
                                            <div className="source-code-right-header">
                                              <div className="source-code-right-header-left">
                                                <div className="file-size">
                                                  <p>/{selectedFile}</p>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              className="source-code-main-run"
                                            // style={{
                                            //   height: "500px",
                                            //   width: "100%",
                                            // }}
                                            >
                                              {fileContentLoading ? (
                                                <Loader
                                                  type={LoaderType.FileContent}
                                                  count={10}
                                                />
                                              ) : (
                                                // <CodeBlock
                                                //   text={
                                                //     fileContent?.content
                                                //       ? fileContent?.content
                                                //       : ""
                                                //   }
                                                //   language={
                                                //     fileContent?.language
                                                //       ? fileContent?.language
                                                //       : "py"
                                                //   }
                                                //   showLineNumbers={true}
                                                //   theme={github}
                                                // />
                                                <>
                                                  <SyntaxHighlighter
                                                    customStyle={{
                                                      height: "100%",
                                                      width: "100%",
                                                    }}
                                                    showLineNumbers={true}
                                                    language={
                                                      typeof fileContent?.language === "string" &&
                                                        fileContent?.language.trim() !== ""
                                                        ? fileContent?.language
                                                        : "py"
                                                    }
                                                    style={a11yDark}
                                                  >
                                                    {typeof fileContent?.content === "string" &&
                                                      fileContent?.content.trim() !== ""
                                                      ? fileContent?.content
                                                      : "{}"}
                                                  </SyntaxHighlighter>
                                                  {/* <SyntaxHighlighter
                                                  customStyle={{
                                                    height: "100%",
                                                    width: "100%",
                                                  }}
                                                  showLineNumbers={true}
                                                  language={
                                                    fileContent?.language
                                                      ? fileContent?.language
                                                      : "py"
                                                  }
                                                  style={a11yDark}
                                                >
                                                  {fileContent?.content
                                                    ? fileContent?.content
                                                    : ""}
                                                </SyntaxHighlighter> */}
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </div>
                                ) : (
                                  <Nodata />
                                )}
                              </>
                            )}
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                    //   </div>
                    // </Col>
                  )}
                </div>
              </Col>
              {/* <Col xl={3}>
              <div className="parentstickey"> */}
              {machineDetailLoading ? (
                <Loader type={LoaderType.MarketMainRight} />
              ) : (
                <Col xl={3}>
                  <div className="developersticky-inner review-checklist-sidebar">
                    <div className="parentstickey">
                      <div className="information-main general-informatio-main general-info">
                        {MachineDetails?.dataList1?.[0]?.isrtirementrecord ? (
                          <div className="deprecated-machine-boxmain">
                            <div className="deprecated-machine-title">
                              <img src={redalert} alt="redalert" />
                              <h2>{`${MachineDetails?.dataList7?.[0]?.requesttype} Machine`}</h2>
                              <p className="reviewbtn">Review</p>
                            </div>
                            <div className="deprecated-machine-dsc">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: MachineDetails?.dataList7?.[0]
                                    ?.userreason
                                    ? MachineDetails?.dataList7?.[0]?.userreason
                                    : "",
                                }}
                              />
                              <div className="from-date">
                                <h2>{`${MachineDetails?.dataList7?.[0]?.requesttype} From`}</h2>
                                <span>
                                  {MachineDetails?.dataList7?.[0]
                                    ?.usersuggestdate
                                    ? commonservices.getDateInFormatCustom(
                                      MachineDetails?.dataList7?.[0]
                                        ?.usersuggestdate,
                                      null,
                                      "MM/DD/YYYY"
                                    )
                                    : "-"}
                                </span>
                              </div>
                            </div>
                            <div className="deprecated-machine-filed">
                              <Form.Group className="form-group">
                                <Form.Label className="common-label">
                                  Comment
                                  <span className="ms-1 red-color-text">*</span>
                                </Form.Label>
                                <div className="position-relative">
                                  <Form.Control
                                    as="textarea"
                                    className="common-input"
                                    style={{ minHeight: "100px" }}
                                    value={retierMentForm?.reviwerreason}
                                    onChange={(e) => {
                                      setRetierMentForm({
                                        ...retierMentForm,
                                        reviwerreason: e.target.value,
                                      });
                                    }}
                                    isInvalid={
                                      retierMentForm?.errors?.reviwerreason
                                    }
                                  />
                                  {retierMentForm.errors.reviwerreason && (
                                    <Form.Control.Feedback type="invalid">
                                      <span className="error-message-icon">
                                        <img
                                          src={infoIcon}
                                          alt="infoIcon"
                                          title={
                                            retierMentForm.errors.reviwerreason
                                          }
                                        />
                                      </span>
                                    </Form.Control.Feedback>
                                  )}
                                </div>
                              </Form.Group>
                              <div className="selectdate">
                                <span>Select Date</span>
                                <div className="position-relative">
                                  <Form.Control
                                    type="date"
                                    className="common-input"
                                    value={retierMentForm?.datebyreviwer}
                                    onChange={(e) => {
                                      setRetierMentForm({
                                        ...retierMentForm,
                                        datebyreviwer: e.target.value,
                                      });
                                    }}
                                    isInvalid={
                                      retierMentForm?.errors?.datebyreviwer
                                    }
                                    min={moment().format("YYYY-MM-DD")}
                                  />
                                  {retierMentForm.errors.datebyreviwer && (
                                    <Form.Control.Feedback type="invalid">
                                      <span className="error-message-icon">
                                        <img
                                          src={infoIcon}
                                          alt="infoIcon"
                                          title={
                                            retierMentForm.errors.datebyreviwer
                                          }
                                        />
                                      </span>
                                    </Form.Control.Feedback>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="d-flex gap-2">
                              <button
                                className="red-outlined-btn"
                                onClick={() => {
                                  if (!retiermentRejectLoading) {
                                    let body = {
                                      machineid: parseInt(id),
                                      versionnumber: version,
                                      datebyreviwer:
                                        retierMentForm?.datebyreviwer,
                                      reviwerreason:
                                        retierMentForm?.reviwerreason,
                                      requesttype:
                                        MachineDetails?.dataList7?.[0]
                                          ?.requesttype,
                                      isapprove: false,
                                      isreject: true,
                                    };
                                    changeMachineRetirementStatus(
                                      body,
                                      setRetiermentRejectLoading
                                    );
                                  }
                                }}
                              >
                                {retiermentRejectLoading ? (
                                  // <>
                                  //   <span>Loading</span>
                                  //   <Spinner
                                  //     className="ms-1"
                                  //     animation="border"
                                  //     role="status"
                                  //     size="sm"
                                  //   >
                                  //     <span className="visually-hidden">
                                  //       Loading...
                                  //     </span>
                                  //   </Spinner>
                                  // </>
                                  <SubmitLoading />
                                ) : (
                                  "Reject"
                                )}
                              </button>

                              <button
                                className="blue-btn"
                                onClick={() => {
                                  if (!retiermentApproveLoading) {
                                    let body = {
                                      machineid: parseInt(id),
                                      versionnumber: version,
                                      datebyreviwer:
                                        retierMentForm?.datebyreviwer,
                                      reviwerreason:
                                        retierMentForm?.reviwerreason,
                                      requesttype:
                                        MachineDetails?.dataList7?.[0]
                                          ?.requesttype,
                                      isapprove: true,
                                      isreject: false,
                                    };
                                    changeMachineRetirementStatus(
                                      body,
                                      setRetiermentApproveLoading
                                    );
                                  }
                                }}
                              >
                                {retiermentApproveLoading ? (
                                  // <>
                                  //   <span>Loading</span>
                                  //   <Spinner
                                  //     className="ms-1"
                                  //     animation="border"
                                  //     role="status"
                                  //     size="sm"
                                  //   >
                                  //     <span className="visually-hidden">
                                  //       Loading...
                                  //     </span>
                                  //   </Spinner>
                                  // </>
                                  <SubmitLoading />
                                ) : (
                                  "Approve"
                                )}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <h2>Checklist</h2>
                            {checkListForMachineReview?.map((item) => {
                              return (
                                <div className="general-informatio-main-inner-wrapper">
                                  <h2 className="mb12">
                                    {item?.title} <span>{item?.subTitle}</span>
                                  </h2>
                                  <div className="all-general-informations-main">
                                    {item?.checkList?.map((checkListItem) => {
                                      return (
                                        <div className="d-flex align-items-center justify-content-between">
                                          <Form.Check
                                            type="checkbox"
                                            id={checkListItem?.title}
                                            label={checkListItem?.title}
                                            checked={
                                              reviewCheckList?.[
                                              checkListItem?.booleanField
                                              ]
                                            }
                                            disabled={machineStatusLoading}
                                            onChange={(e) => {
                                              let body = {
                                                machineid: id
                                                  ? parseInt(id)
                                                  : 0,
                                                versionnumber: MachineDetails
                                                  ?.dataList1?.[0]
                                                  ?.versionnumber
                                                  ? MachineDetails
                                                    ?.dataList1?.[0]
                                                    ?.versionnumber
                                                  : "",
                                                booleanfield:
                                                  checkListItem?.booleanField,
                                                booleanfieldvalue:
                                                  e?.target?.checked,
                                                commentfield:
                                                  checkListItem?.commentField,
                                                commentfieldvalue: "",
                                              };
                                              updateReviewStatus(body);
                                              handleCheckListStatus(
                                                body?.booleanfield,
                                                body?.booleanfieldvalue,
                                                body?.commentfield,
                                                body?.commentfieldvalue
                                              );
                                            }}
                                          />
                                          {!reviewCheckList?.[
                                            checkListItem?.booleanField
                                          ] &&
                                            !reviewCheckList?.[
                                            checkListItem?.commentField
                                            ] ? (
                                            <span
                                              className="accept-reject rejected"
                                              onClick={(e) => {
                                                reviewCommentModalRef.current =
                                                {
                                                  heading:
                                                    checkListItem?.title,
                                                  body: {
                                                    machineid: id
                                                      ? parseInt(id)
                                                      : 0,
                                                    versionnumber:
                                                      MachineDetails
                                                        ?.dataList1?.[0]
                                                        ?.versionnumber
                                                        ? MachineDetails
                                                          ?.dataList1?.[0]
                                                          ?.versionnumber
                                                        : "",
                                                    booleanfield:
                                                      checkListItem?.booleanField,
                                                    booleanfieldvalue: false,
                                                    commentfield:
                                                      checkListItem?.commentField,
                                                    commentfieldvalue: "",
                                                  },
                                                  submitDisable: false,
                                                };
                                                setRejectModalShow(true);
                                              }}
                                            >
                                              Reject
                                            </span>
                                          ) : !reviewCheckList?.[
                                            checkListItem?.booleanField
                                          ] &&
                                            reviewCheckList?.[
                                            checkListItem?.commentField
                                            ] ? (
                                            <img
                                              src={comment}
                                              onClick={(e) => {
                                                reviewCommentModalRef.current =
                                                {
                                                  heading:
                                                    checkListItem?.title,
                                                  commentField:
                                                    reviewCheckList?.[
                                                    checkListItem
                                                      ?.commentField
                                                    ],
                                                  submitDisable: true,
                                                };
                                                setRejectModalShow(true);
                                              }}
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              );
                            })}
                            <div className="d-flex gap-2">
                              <button
                                className={`${isButtonDisabled("Reject")
                                  ? "disabled-btn"
                                  : "red-outlined-btn"
                                  }`}
                                disabled={isButtonDisabled("Reject")}
                                onClick={(e) => {
                                  setShowRejectMachine(true);
                                }}
                              >
                                Reject
                              </button>
                              <button
                                className={`${isButtonDisabled("Approve")
                                  ? "disabled-btn"
                                  : "blue-btn"
                                  }`}
                                disabled={isButtonDisabled("Approve")}
                                onClick={(e) => {
                                  if (!machineStatusLoading) {
                                    updateMachineStatus("Publish");
                                  }
                                }}
                              >
                                {machineStatusLoading ? (
                                  // <>
                                  //   <span>Loading</span>{" "}
                                  //   <Spinner
                                  //     className="ms-1"
                                  //     animation="border"
                                  //     role="status"
                                  //     size="sm"
                                  //   >
                                  //     <span className="visually-hidden">
                                  //       Loading...
                                  //     </span>
                                  //   </Spinner>
                                  // </>
                                  <SubmitLoading />
                                ) : (
                                  "Approve"
                                )}
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              )}
              {/* </div>
              </Col> */}
            </Row>
          </div>
        </Container>
      </div>
      {rejectModalShow && (
        <RejectModal
          onHide={(e) => setRejectModalShow(false)}
          show={rejectModalShow}
          checkListData={reviewCommentModalRef.current}
          updateReviewStatus={updateReviewStatus}
          getReviewStatus={getReviewStatus}
          handleCheckListStatus={handleCheckListStatus}
        />
      )}
      {showRejectMachine && (
        <MachineRejectModal
          onHide={(e) => setShowRejectMachine(false)}
          show={showRejectMachine}
          updateMachineStatus={updateMachineStatus}
        />
      )}
      {showInputDetailPopup && (
        <Overlay
          target={targetInputDetail.current}
          show={handleShowInputDetailPopup}
          placement="bottom"
        >
          <Tooltip id="overlay-example">
            <InputDetail
              handleshowPopup={handleShowInputDetailPopup}
              compObj={paraDetailRef.current}
            />
          </Tooltip>
        </Overlay>
      )}
    </div>
  );
}

export default MachineReview;
